import React from 'react';
import classNames from 'classnames';
import './skeleton.css';

function TextSkeleton({ className }: { className?: string }) {
  return (
    <div role="status" className={classNames('sk-root sk-text', className)}>
      <div className="sk-line" />
      <div className="sk-line" />
      <div className="sk-line" />
      <div className="sk-line" />
      <div className="sk-line" />
      <span className="sr-only">Loading...</span>
    </div>
  )
}

export default TextSkeleton